import React from 'react'
import "./TermsCondition.css"
import { Link, useNavigate } from 'react-router-dom';
function TermsCondition() {
    const navigate = useNavigate();
    const previouseScreen = () => {
        navigate(-1);
    }
    return (
        <div class="container-fluid  global_container BathHeader">
            <div className='p-3'>
                <div className="row mb-2">
                    <div className="col-md-6 col-12">
                        <h2 className="TitleHeader"> Terms & Conditions </h2>
                    </div>
                    <div className="col-md-6 col-12 ListBtn">
                        <ul class="List-Button">
                            <li class="ListBtnItems">
                                <Link
                                    to={"javascript:void(0)"}
                                    onClick={previouseScreen}
                                    className="secondaryButton "
                                    variant="secondary"
                                >
                                    Back
                                </Link>
                            </li>


                        </ul>
                    </div>
                </div>
                <div class="">
                    <p>
                        These terms and conditions (hereinafter referred to as Terms) governs the manner in which
                        ANNA IAS ACADEMY (hereinafter referred to as AIASA) collects, uses, maintains and discloses
                        information collected from users of the  <a style={{ fontWeight: "bold", fontSize: "14px" }} href='/'>www.annaiasacademy.com </a> website and the
                        business operation of AIASA.
                    </p>
                    <p>
                        These terms apply to this website, all products and services as offered by AIASA. Users of this
                        website are requested to please read these Terms carefully before using this website, which is
                        operated and owned by AIASA.
                    </p>
                    <p>
                        Your access to and use of this website service is conditioned on your acceptance of and
                        compliance with these Terms. These Terms apply to all visitors, users and others who access or
                        use the services in this website.
                    </p>
                    <p>
                        By registering on this website or by subscribing to a service provided in this website and by
                        providing your contact details, viz Name, Address, Adhaar number telephone number, email,
                        mobile number, shipping address, etc., User hereby give their consent, for the purpose of
                        receiving information about products and services offered by AIASA. User also hereby give their
                        consent that AIASA may contact you in future to provide information regarding its products and
                        services by using the information that they have provide to AIASA.
                    </p>

                    <a href='#' className="subTitleHeader">USER PERSONAL IDENTIFICATION INFORMATION</a>
                    <p>
                        AIASA is committed to safe guard personal identification information of the users such as users
                        name, address, telephone, email, mobile number, shipping address, personal information etc.,.
                        Such information which has been shared in our website by the users will be stored in secure
                        manner and will be used by AIASA only for academic purposes. AIASA has adequate security
                        measures to protect against unauthorized access, alteration, disclosure or destruction of users
                        personal information, username, password, transaction information and data stored on AIASA
                        website. AIASA will not share users’ personal identification information with any third party for
                        any reason whatsoever. AIASA assures that the information shared by users will be secure and
                        will be treated as privileged information.
                    </p>

                    <a href='#' className="subTitleHeader">COURSE FEE - NON REFUNDABLE</a>

                    <p>
                        Candidates must understand the rules pertaining to payment of fees, before enrolling to any
                        course offered by AIASA. The fees and other dues, once paid, under no circumstances is
                        refundable, adjustable or transferable. AIASA shall not entertain any kind of refund once a
                        candidate has been enrolled to a program. Candidates who discontinue in the middle of the course
                        for whatever reason shall not be entitled to seek refund of the course fee. No disputes regarding
                        refunds will be entertained by AIASA once the fees are paid.<span style={{ color: "red" }}> These terms and conditions shall be governed by and constructed according to the laws in force in India. The Candidates and other
                            users of this website shall hereby submit to the jurisdiction of the courts situated at Chennai for
                            the purpose of actions and proceedings arising out of the terms and conditions. The courts at
                            Chennai shall have the sole jurisdiction to hear and decide such actions and proceedings.  </span>
                    </p>
                    <a href='#' className="subTitleHeader">COURSE MATERIALS</a>
                    <p>
                        Candidates, who have enrolled to course offered by AIASA, shall attend the course only in the
                        respective admission category and in no circumstances mode of class / test will be changed.
                        Candidates in order to attend online test, online class should have adequate technological
                        resources at their end. The candidates shall not have any right or claim on the course materials
                        provided by AIASA. This shall include hard and soft copies of course material. AIASA shall be the
                        sole owners of all the course material or other study material issued by AIASA as part of the
                        course. Candidates shall not claim any ownership whatsoever on the content or the physical
                        copies of the course material.
                    </p>


                    <p>
                        Candidates who have enrolled for the course will be given access to watch online study videos,
                        which will be available in AIASA website, these videos have been designed to provide better
                        understanding to the candidates on the subject matter of the course. AIASA have invested
                        considerable time and resource in making these study videos and study materials, the only
                        intention of these study videos and materials is dissemination of knowledge to the candidates.
                        These study videos and materials are the properties of AIASA and Candidates shall have the right
                        only to watch the videos in the AIASA website and shall be prohibited to make copy of the videos
                        by following any method or means. Similarly study materials issued by AIASA are only for the
                        personal use of the enrolled candidates and not for public usage and circulation. Candidates are prohibited from manipulating study videos and study materials in any manner. If the management
                        finds that any candidate has in any manner manipulated any material and commercially exploited
                        the resource content of AIASA, such candidate shall be expelled from AIASA with immediate
                        effect and AIASA shall hold all rights in its capacity to initiate, appropriate legal action against
                        such candidate and users of this website.

                    </p>

                    <a href='#' className="subTitleHeader">CANCELLATION OF ADMISSION</a>
                    <p>
                        The courses offered by AIASA is tailored to train the candidates within a specific period and within
                        stipulated time span, in any event if the candidate discontinues or leaves midway his\her course
                        for reasons whatsoever, AIASA shall not have any obligation to refund, adjust or transfer the fee
                        paid by the candidate. Candidates enrolled to any course offered by AIASA may apply for
                        cancellation of his\her admission at any time during the tenure of the course, in such event also
                        AIASA shall not have any obligation to refund the fee paid by the candidate. Candidates who have
                        discontinued the course shall have no right to claim any course materials from AIASA. Admission
                        once cancelled will not be re-considered and fee paid will not be refunded under any
                        circumstances. Candidates, who have discontinued the course midway, if they wish to seek
                        readmission, subject to the discretion of AIASA, they shall have to apply for admission as fresh
                        candidates and shall have to pay the prescribed course fee
                    </p>
                    <p>
                        The courses offered by AIASA are time bound and have been formulated to assess the candidates
                        on periodic basis, in light of the same, AIASA shall conduct periodic online assessment test to the
                        enrolled candidates. Candidates are expected to attend these assessment tests diligently, as the
                        results of these tests will help AIASA and the enrolled candidate to identifying the strengths and
                        weaknesses of the Candidates. AIASA expects the candidate to attend the entire assessment
                        test, conducted during the course period. Any candidate who fails to appear for three continuous
                        assessment tests shall be presumed by AIASA as non-serious candidates and AIASA shall
                        reserve the right to cancel the admission of such candidates and any such users of this website
                    </p>
                    <a href='#' className="subTitleHeader">USE OF AIASA ONLINE PORTAL
                    </a>
                    <p>
                        AIASA as part of its course training shall upload various study videos in its website. Candidates
                        enrolled for any course offered by AIASA shall be provided with login credentials, which will assist
                        them to watch the study videos from the website of AIASA. These study videos and materials are
                        the properties of AIASA and the candidates shall make use of these videos to equip their subject knowledge. Candidates are prohibited from sharing their login credentials to any third person who
                        has not enrolled with any course offered by AIASA. A candidate’s login credentials shall be used
                        only by the said candidate and sharing of login credentials is completely barred and prohibited. If
                        such violations are found to have occurred, AIASA shall reserve its rights to take appropriate
                        action against such candidate including, but not limited to cancellation of admission to such
                        candidates.
                    </p>
                    <p>
                        Candidates shall have the right to use their login credentials to watch study videos and to
                        accesses study material which are uploaded in the AIASA website only during the duration of their
                        course period. On completion of their course period the login credentials will be deactivated by
                        AIASA. There is no right vested with the candidate to claim any course materials or access to the
                        website of AIASA.
                    </p>
                    <p style={{ color: "red" }}>
                        Candidates who were, coached and trained for any course by AIASA, in the event of them clearing
                        TNPSC exam or any other exam, AIASA shall reserve the right to publish in its website the Name,
                        Photo and exam registration number of such Candidates. AIASA shall initiate appropriate legal
                        action against such persons or coaching institutes who falsely claim, to have provided coaching
                        or training to any Candidates who were actually coached and trained by AIASA.
                    </p>

                    <a href='#' className="subTitleHeader">CHANGES TO THIS PRIVACY POLICY</a>
                    <p>
                        AIASA reserve all rights to modify these terms and conditions at any time, users may please
                        review it frequently. Any changes and clarifications brought in the terms will take effect
                        immediately and will be posted on this website. Users who would like to: access, correct, amend
                        or delete any personal identification information AIASA have about you, may register a complaint,
                        and may contact us via email at <a style={{ fontWeight: "bold", fontSize: "14px" }} href="mailto:support@annaiasacademy.com" >support@annaiasacademy.com </a>.
                    </p>

                    <a href='#' className="subTitleHeader" >CONTACTING US</a >
                    <p>
                        If users have any questions or concerns about these terms and conditions of the website or the
                        operation of this website, users may please free to, contact us at :
                        <a style={{ fontWeight: "bold", fontSize: "14px" }} href="mailto:support@annaiasacademy.com" >support@annaiasacademy.com </a>.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default TermsCondition;